import { ObjectIdSchema } from '@weft/types';
import { oz } from '@weft/utils';
import { InvoiceSyncAttemptErrorReasonSchema } from './invoice-sync-attempt-error-reason';

export const InvoiceSyncAttemptResultSchema = oz.object({
  invoiceId: ObjectIdSchema,
  invoiceName: oz.string(),
  customerId: oz.string(),
  customerName: oz.string(),
  errorReason: InvoiceSyncAttemptErrorReasonSchema.optional(),
}).openapi('invoiceSyncAttemptResult');

export type InvoicesSyncAttemptResult = oz.infer<typeof InvoiceSyncAttemptResultSchema>;